<template>
  <div style="display: inline-flex">

    <Dialog :visible="visible" class="nonstop-temperature-select-dialog" :modal="true" 
            :closable="false" :style="{width: '90vw', minWidth: '460px', maxWidth: '1200px'}" :breakpoints="{'820px': '100vw'}" :draggable="false" >

      <template #header>{{$t('library.cycle.nonstop_temperature_dialog')}}</template>

      <div class="">

        <vueper-slides ref="phases" class="no-shadow ex--center-mode"
        :visible-slides="3"
        :dragging-distance="70" 
        :slideMultiple="true"
        fixed-height="330px"
        :bullets="false"
        :bullets-outside="false"
        :breakpoints="{ 1000: { visibleSlides: 2 }, 700: { visibleSlides: 1 } }"      
              >      

          <template #arrow-left>
            <img src="assets/irinox/icons/carousel_left.svg"   :alt="$t('common.previous')"/>
          </template>

          <template #arrow-right>
            <img src="assets/irinox/icons/carousel_right.svg"   :alt="$t('common.next')"/>
          </template>

          <vueper-slide
              v-for="temp in nonStopTemperatures"
              :key="'nonstop_temp_'+temp"
              :title="temp.toString()"
              :style="'background-color: white'" 
              >
            <template #content>
              <div class="p-m-2">
                <div class="library-select-nonstop-temperature p-d-flex p-flex-column p-text-center p-ai-center"
                    @mouseup="temperatureSelected(temp)" @mousedown="mousedown" @mousemove="mousemove">
                  <div>
                    <span :class="'icon-air_temp'"  style="font-size: 100px;" />
                  </div>
                  <div class="nonstop-temperature">
                    <span>{{$functions.temperature(temp*10,isCelsius)}}{{unit}}</span>
                  </div>
                </div>
              </div>
            </template>
          </vueper-slide>

        </vueper-slides>
        
      </div>

      <template #footer></template>

    </Dialog>

  </div>

</template>

<script>

import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';
import { mapGetters } from 'vuex';

export default {
  emits: ['select:temperature'],
  components: {
      VueperSlides, 
      VueperSlide,
    },
    props: {
      visible: Boolean,
    },
    data() {
        return {
          drag: false,
          nonStopTemperatures: [-35,-25,0]
        };
    },
    computed: {
      ...mapGetters({
          unit: 'userdata/unit',
          isCelsius: 'userdata/isCelsius',
        }),
    },
    watch: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
      mousedown() {
        this.drag = false;
      },
      mousemove() {
        this.drag = true;
      },
      temperatureSelected(temp) {
        if(!this.drag) {
          this.$emit("select:temperature", temp);
        }
      },
    }

}
</script>

<style scoped>

</style>